import React from 'react'
import pic1 from '../Components/images/ourteam/pic1.jpg'
import pic2 from '../Components/images/ourteam/pic2.jpg'
import pic3 from '../Components/images/ourteam/pic3.jpg'
import pic4 from '../Components/images/ourteam/pic4.jpg'
import pic5 from '../Components/images/ourteam/pic5.jpg'
import pic6 from '../Components/images/ourteam/pic6.jpg'
import pic7 from '../Components/images/ourteam/pic7.jpg'
import pic8 from '../Components/images/ourteam/pic8.jpg'

const Team = () => {
    return (
        <>
            <div className="overflow-hidden relative bg-[#F1F2F2] mx-0 md:mx-[2rem]">
                <div className="bg7 ">
                    <div className="md:w-[67%] w-full  md:left-[25%] top-12 bottom-0 relative">
                        <div className="mx-[1rem] md:mx-0">
                            <div className="">
                                <h1 className='text-[2.5rem]  font-black text-[#004A8B]'>Who we are</h1>
                                <h1 className='border-b-[.4rem]  border-[#B5D1B3] w-[3.5rem]'></h1>
                            </div>
                            <div className="">
                                <p className='md:text-[1.1rem] py-12 text-[1.1rem]  tracking-wide'>
                                    We are real estate land specialists. Our experts provide market leading transactional services and advice.
                                </p>

                            </div>

                        </div>

                    </div>

                    <div className="mx-[1rem] md:py-8 md:mx-0">
                        <div className="">
                            <h1 className='text-[#004A8B] md:pt-6 my-3 pt-20 relative z-20 font-black text-[30px]'>Executive</h1>
                        </div>

                        <div class="grid grid-cols-12 gap-2 md:gap-6">

                            <div class="md:col-span-3  col-span-6 relative group overflow-hidden">
                                <a href="" className='' >
                                    <img src={pic1} alt="" className='group-hover:scale-105 transition-all ease-in-out  duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Rob Blain</span>
                                        <span>Chairman</span>
                                    </span>
                                </a>
                            </div>

                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic2} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Elizebath Doly</span>
                                        <span>Director</span>
                                    </span>
                                </a>
                            </div>

                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic3} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Erica Semmens</span>
                                        <span>Director</span>
                                    </span>
                                </a>
                            </div>

                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic4} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Danny Thomas</span>
                                        <span>Senior Director</span>
                                    </span>
                                </a>
                            </div>

                        </div>


                        <div class="grid grid-cols-12 gap-6 my-6">

                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic5} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Col Medway</span>
                                        <span>Senior Director</span>
                                    </span>
                                </a>
                            </div>


                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic6} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Rowan Delay</span>
                                        <span>Analyst</span>
                                    </span>
                                </a>
                            </div>


                        </div>
                        
                        <div className="">
                            <h1 className='text-[#004A8B] md:pt-6 my-3  relative z-20 font-black text-[20px] md:text-[30px]'>Agribusiness Transaction</h1>
                        </div>

                        <div class="grid grid-cols-12 gap-6">

                            <div class="md:col-span-3  col-span-6 relative group overflow-hidden">
                                <a href="" className='' >
                                    <img src={pic7} alt="" className='group-hover:scale-105 transition-all ease-in-out  duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Darren Colins</span>
                                        <span>Director</span>
                                    </span>
                                </a>
                            </div>

                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic8} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Sadd Tim</span>
                                        <span>Analyst</span>
                                    </span>
                                </a>
                            </div>

                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic5} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Col Medway</span>
                                        <span>Senior Director</span>
                                    </span>
                                </a>
                            </div>


                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic6} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Rowan Delay</span>
                                        <span>Analyst</span>
                                    </span>
                                </a>
                            </div>
                        </div>

                        <div class="grid grid-cols-12 gap-2 py-6 md:gap-6">

                            <div class="md:col-span-3  col-span-6 relative group overflow-hidden">
                                <a href="" className='' >
                                    <img src={pic1} alt="" className='group-hover:scale-105 transition-all ease-in-out  duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Rob Blain</span>
                                        <span>Chairman</span>
                                    </span>
                                </a>
                            </div>

                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic2} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Elizebath Doly</span>
                                        <span>Director</span>
                                    </span>
                                </a>
                            </div>

                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic3} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Erica Semmens</span>
                                        <span>Director</span>
                                    </span>
                                </a>
                            </div>

                            <div class="md:col-span-3 col-span-6 relative group overflow-hidden">
                                <a href=""  >
                                    <img src={pic4} alt="" className='group-hover:scale-105 transition-all ease-in-out duration-300' />
                                    <span className='absolute bg-[rgba(0,74,139,0.6)] h-full w-full top-0 left-0'>
                                    </span>
                                    <span className='md:absolute relative md:bg-[rgba(0,74,139,0)] bg-white md:top-[14rem] w-full block md:text-white px-4 py-4'>
                                        <span className='block font-black relative'>Danny Thomas</span>
                                        <span>Senior Director</span>
                                    </span>
                                </a>
                            </div>

                        </div>


                    </div>


                </div>
            </div>
        </>
    )
}

export default Team